import { useEffect, useState } from "react";
import DataTable from "../../components/shared/DataTable/DataTable";
import DataService from "../../Services/DataService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../App/store";
import { changeRank } from "../../App/Slices/userSlice";

export const LeaderBoard = () => {
  const [tableData, setTableData] = useState<any>([]);
  const userSelector = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    let users = await DataService.resources.user.getAll({
      queryParams: {
        // sort: { "scores.win": -1, "scores.kill": -1, "scores.damage": -1 },
        sort: { "scores.win": -1 },
        // limit: 10,
      },
    });

    const index = users.findIndex((user) => user._id == userSelector.user._id);
    dispatch(changeRank(index + 1));
    users = users.splice(0, 10);
    setTableData(
      users.map((user, index) => {
        return {
          _id: user._id,
          nick_name: user.nick_name,
          rank: index + 1,
          wins: (user.scores as any).win,
          damage_done: (user.scores as any).damage,
          kills: (user.scores as any).kill,
        };
      })
    );
  };
  const headers = [
    { title: "Rank", field: "rank" },
    { title: "Nickname", width: "12.24rem", field: "nick_name" },
    { title: "Wins", field: "wins" },
    { title: "Kills", field: "kills" },
    { title: "Damage Done", field: "damage_done" },
  ];

  return <DataTable headers={headers} data={tableData}></DataTable>;
};
export default LeaderBoard;
